export default __webpack_public_path__ + "static/media/bikaner1.b05a36cb.jpg";